import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import DailyTracker from "@/pages/DailyTracker";
import ActivityPage from "@/pages/ActivityPage";
import Master from "@/pages/Master";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center bg-navy-900 text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/daily-log" element={<DailyTracker />} />
        <Route path="/education" element={<ActivityPage activityType="education" />} />
        <Route path="/ppt" element={<ActivityPage activityType="ppt" />} />
        <Route path="/shoots" element={<ActivityPage activityType="shoots" />} />
        <Route path="/training" element={<ActivityPage activityType="training" />} />
        <Route path="/rd" element={<ActivityPage activityType="rd" />} />
        <Route path="/master" element={<Protected roles={["founder","manager"]}><Master /></Protected>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" richColors closeButton />
      </BrowserRouter>
    </AuthProvider>
  );
}
